import { Injectable } from '@angular/core';

import { Effect, Actions } from '@ngrx/effects';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { of } from 'rxjs/observable/of';
import * as fromRouter from '../actions';
import * as appActions from '../actions/app.actions';
import { AppLocalStorage } from '../../helpers';

@Injectable()
export class AppEffects {
  constructor(private actions$: Actions) { }


  @Effect()
  error$ = this.actions$.ofType(appActions.AppActionTypes.Error).pipe(
      map((action: appActions.Error) => action.payload),
      map(error => {
        return new fromRouter.Go({
        path: ['/error'],
      });
    })
  );
}



// WEBPACK FOOTER //
// ./src/app/core/store/effects/app.effects.ts